import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled, { css } from 'styled-components';
import { fontFamily } from '@atlaskit/theme';
export var hiddenMixin = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  clip: rect(1px, 1px, 1px, 1px);\n  clip-path: inset(50%);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n"])));
export var TooltipContent = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  /* CSS reset */\n  font-family: ", ";\n"])), fontFamily);